import Themeable from "vuetify/lib/mixins/themeable";
import {
	VBtn,
	VCard,
	VCol,
	VContainer,
	VHover,
	VIcon,
	VImg,
	VProgressLinear,
	VRow,
	VSheet
} from "vuetify/lib";
import { KActionDialog, KFullscreenDialog } from ".";
import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default {
	name: "KImageManager",

	mixins: [ Themeable ],

	props: {
		images: {
			default: () => [],
			type: Array
		},

		fullHeight: {
			default: 1000,
			type: Number
		},

		fullWidth: {
			default: 1000,
			type: Number
		},

		itemKey: {
			default: "id",
			type: String
		},

		itemFullHeightKey: {
			required: true,
			type: String
		},

		itemFullKey: {
			required: true,
			type: String
		},

		itemFullWidthKey: {
			required: true,
			type: String
		},

		itemThumbKey: {
			required: true,
			type: String
		},

		loading: Boolean,

		thumbHeight: {
			default: 100,
			type: Number
		},

		thumbWidth: {
			default: 100,
			type: Number
		},

		title: {
			required: true,
			type: String
		}
	},

	methods: {
		pickFile() {
			this.$refs.image.click();
		},

		onPickImages( e ) {
			const files = e.target.files || e.dataTransfer.files;

			if ( files.length ) {
				this.$emit( "addImages", files );
			}

			this.$refs.image.value = null;
		},

		onDeleteImage( image ) {
			this.$emit( "deleteImage", image );
		},

		genThumbnail( image ) {
			return <VCol class="shrink" key={getObjectValueByPath( image, this.itemKey )}>
				<VHover scopedSlots={{
					default: ( { hover } ) =>
						<VCard
							class={{
								"grey darken-4": hover && this.isDark,
								"grey lighten-3": hover && !this.isDark
							}}
							hover
							outlined
							ripple
						>
							<KFullscreenDialog
								dark
								scopedSlots={{
									activator: ( { on } ) =>
										<VImg
											contain
											height={this.thumbHeight}
											on={on}
											src={getObjectValueByPath( image, this.itemThumbKey )}
											width={this.thumbWidth}
										></VImg>,

									toolbar: ( { close } ) =>
										<KActionDialog
											confirmButtonColor="error"
											confirmButtonText="Delete"
											loading={this.$wait.is( "delete image" )}
											onConfirm={() =>
												new Promise( () => {
													close();
													this.onDeleteImage( image );
												} )
											}
											title="Delete Image"
											scopedSlots={{
												activator: ( { on: onActionDialog } ) =>
													<VBtn on={onActionDialog} text>
														<VIcon left>delete</VIcon> Delete
													</VBtn>
											}}
										>Are you sure you want to delete this image?</KActionDialog>
								}}
							>
								<VRow
									align="center"
									class="fill-height ma-0"
									justify="center"
								>
									<VImg
										contain
										maxHeight={getObjectValueByPath( image, this.itemFullHeightKey )}
										maxWidth={getObjectValueByPath( image, this.itemFullWidthKey )}
										src={getObjectValueByPath( image, this.itemFullKey )}
									></VImg>
								</VRow>
							</KFullscreenDialog>
						</VCard>
				}}></VHover>
			</VCol>;
		},

		genThumbnails() {
			return this.images.map( this.genThumbnail );
		}
	},

	render() {
		return <VCard outlined>
			<input
				accept="image/*"
				class="d-none"
				multiple
				onChange={this.onPickImages}
				ref="image"
				type="file"
			/>

			<VSheet class="pa-3 white--text" color="grey darken-4" tile>
				{this.title}
			</VSheet>

			{this.loading && <VProgressLinear
				backgroundColor="grey"
				class="ma-0"
				color="primary"
				height="3"
				indeterminate
			></VProgressLinear>}

			<VContainer>
				<VRow>
					<VCol class="shrink">
						<VHover scopedSlots={{
							default: ( { hover } ) =>
								<VCard
									class={{
										"grey darken-4": hover && this.isDark,
										"grey lighten-3": hover && !this.isDark
									}}
									height={this.thumbHeight}
									hover
									onClick={this.pickFile}
									outlined
									width={this.thumbWidth}
								>
									<VRow
										align="center"
										class="fill-height ma-0"
										justify="center"
									>
										<VIcon xLarge>add_a_photo</VIcon>
									</VRow>
								</VCard>
						}}></VHover>
					</VCol>

					{this.genThumbnails()}
				</VRow>
			</VContainer>
		</VCard>;
	}
};
